import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React from "react";
import useCERData from "../../Hooks/useCERData/useCERData";
import useCERModule from "../RecipientDetail/CERModule/hooks/useCERModule";
import GoalsList from "./GoalsList";
import { PathTypeContext } from "./PathTypeContext";

const PathTypesList = ({ constants }) => {
  const { pathTypes } = useCERData();
  const { recipientCER } = useCERModule();

  const filteredPathTypes = pathTypes.filter((pt) => {
    return recipientCER.goals.find((g) => g.pathType == pt.id);
  });

  var styles = StyleSheet.create({
    container: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "grey",
      padding: 10,
      marginTop: 10,
    },
    title: {
      fontSize: 13,
      paddingBottom: 4,
    },
  });

  return filteredPathTypes.map((pathType) => {
    return (
      <View style={{ ...styles.container }} key={`pathtype${pathType.id}`} wrap={false}>
        <Text style={{ ...styles.title }}>{pathType.name}</Text>
        <PathTypeContext.Provider value={pathType}>
          <GoalsList constants={constants} />
        </PathTypeContext.Provider>
      </View>
    );
  });
};

export default PathTypesList;
